/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

// TODO Jak nakládat s nekonečnými událostmi, aby výpočet nezacyklil?
// - Plánovat po částech a až potom se rozhodovat,
//   jestli je navazující událost stejná?
//   Vázalo by se vždy na max. jednu událost, nebo instanci opakování.
//   Tím by šlo dosáhnout "nekonečnosti" pomocí konečného seTimeout.
//   Předpočet by tam probíhal pouze na dobu, po kterou se využije.
// - Plánování do neomezené budoucnosti zatím omezit maximálním počtem opakování.
//   V budoucnu by se přešlo na vnitřní implementaci přes iterátory a nikoliv
//   přes IcalExpander, čímž by šlo bez problému plánovat i do nekonečna.
//   Stačí totiž vždy znát jen následující opakování události a ne všechny
//   do nekonečna.
// TODO Ukládat currentPlan a nextPlan pro další iteraci jako previousPlan a currentPlan.
// TODO Přidat možnost maximálního datumu, do kterého se bude vyhledávat.
// - Nahradit atDate za startDate
// - Přidat endDate
// TODO Podpora duration a nevyplněného endDate pří výpočtech
// TODO Spojit implementace findNextPlan, findPreviousPlan do jednoho univerzálního algoritmu.
// TODO Implementovat také rozhraní Iterable?
// - Chybí podpora Symbol ve starém Chrome.
//   Mělo by jít řešit při transpilaci, ale pravděpodobně bude nutné nastavení.
// - Zatím se asi nikde reálně používat nebude.
// TODO Vyčlenění implementace ContentTaskIcalPlanIterator
// - Bylo by to lepší pro testy, kde by se zjišťovala konkrétní událost a ne
//   jen úloha, která má více událostí.
// - Tato třída by jen převáděla ICAL.Time na Date a naopak.
// TODO Vyčlenění implementace jako generics typ
// - Hodnotami by byly dvojice {ical, T} případně {jcal, T}
// - Univerzální a znovupoužitelné
// - Dává smysl vyčlenit logiku výběru ical mimo tuto třídu.
// - Podporuje nasazení jCal formátu
// TODO Algoritmus spoléhá na unikátnost všech UID ve všech kalendářích.
// - Pro podporu výpočtu nad stejnými UID by se musely výpočty provádět nad jCal
//   a ne nad iCal formátem.
//   Všechny algoritmy (i IcalExpander) by operovali nad stejným jCal objektem,
//   k porovnání událostí by se použilo `===` mezi jejich jCal instancemi,
//   místo aktuálního porovnání jejich UID.
// TODO Ošetření více aktivních událostí v rámci jednoho kalendáře:
// - Jít cestou nejlepšího výkonu (aktuální řešení)
//   - Prioritu určuje pořadí události v kalendáři a nic jiného.
//   - Uživatel nemůže prioritu jednoduše ovlivnit, protože jde spíš o interní
//     informaci iCalendar formátu.
//   - Lehce to zkomplikují opakování, které bude nutné prioritiozvat primárně
//     dle pořadí rodičovské události a sekundárně dle pořadí v opakování.
//     Je otázkou, jak nakládat s výjimkami z opakovaní.
//     Uvažovat jejich potencionálně upravený startDate?
//     Nebo dodržovat striktně "původní" pořadí z IcalApi.RecurIterator?
// - Snažit se vytvořit co nejméně iterací (další možné řešení)
//   - Priority dle startDate (co nejdříve), endDate (co nejpozději) a pak id?
//   - Přeskočí události, které mají <startDate, endDate) uvnitř jiné události.
//   - Je nutné projít všechny události v kalendáři, i ta poslední může rozhodnout.
//   - Složitější algoritmus, pomalejší, ale více intuitivní "na papíře".
//   - Na druhou stranu se stejně v hlavním plánovacím API stejně neprojeví.
//     I tak budou vznikat "nenavazující" iterace, ve kterých se nemění úloha.
//     Slučování se musí řešit ve vyšší úrovni nad omezeným počtem plánů,
//     protože zde může zacyklit, když by na sebe opakované úlohy donekonečna.
// TODO Opakované inicializace IcalExpander
// - Buď zde předpočítat, nebo ještě lépe refaktorizovat IcalExpander, aby pracoval nad jCal.
// - Také zde chybí omezení opakovaných úloh, bude stačit omezení na iterace?
// TODO Optimalizace algoritmu snižováním datumu vyhledávání
// - Týká se to metod findNextOccurrence a findPreviousOccurrence.
//   Pokud je v nějaké předchozí úloze nalezena aktivní událost, stačí
//   vyhledávat pouze do začátku (respektive pouze do konce u předchozí).
//   Když již byla prioritnější událsot nalezena, nebohou ji události z úloh
//   s nižší prioritou přerušit a tím ji v akumulátoru nahradit.
// TODO Optimalizace algoritmu zastavením při currentDate +- 1
// - Týká se to metod findNextOccurrence a findPreviousOccurrence.
//   U nich by šlo vyhledávání přerušit po nalezení události s časem
//   currentDate + 1, respektive currentDate - 1 u předcházející.
//   U takové události je jisté, že jde o hledanou následující / předcházející,
//   jelikož již nemůže žádná událost začínat dříve / později.
// TODO Optimalizace algoritmu předáváním jCal místo iCal
// TODO Optimalizace algoritmu na základě využití postupného procházení
// - Využije se iCal API RecurIterator, respektive něco ve stylu EventIterator,
//   co by fungovalo na rozhraní Iterator a uvažovalo by i výjimky z opakování.
// TODO Nejsou podporovány úlohy bez kalendáře, vyhazuje chybu.
// - Zatím není potřeba, všechny úlohy kalendáře mají.
//   Úlohy bez kalendářů musí být odfiltrovány ve vyšší třídě a speciálně
//   ošetřené, např. odlišnou logikou plánování.
// - Pokud by zde přesto byl požadavek na podporu těchto úloh, největší smysl
//   by pravděpodobně dávalo zavést nový boolean vstup, který by určoval,
//   jestli je úloha bez kalendáře vždy platná, nebo vždy neplatná.
//   Anebo ještě více propracovat pomocí callbacku, který bude mít na vstupu
//   úlohu a na výstupu zmiňovaný boolean.
/**
 * Iterátor plánu obsahových úloh
 *
 * Určuje posloupnost, ve kterém se mají obsahové úlohy přehrávat.
 * Postupně prochází potencionálně nekonečný plán úloh.
 *
 * Každá úloha má uložený svůj plán ve svém kalendáři ve formátu iCalendar.
 * V každém kalendáři je uloženo teoreticky neomezené množství událostí.
 * Pokud je v nějaký okamžik aktivní libovolná událost, znamená to,
 * že by měla být obsahová úloha, jejíž kalendář má tuto událost, také aktivní.
 *
 * Ve výsledné iteraci se jednotlivé plány nikdy nepřekrývají, maximálně na sebe
 * těsně navazují tak, že konec první úlohy je začátkem úlohy následující.
 * Ze specifikace iCalendar koncové datum do události již nepatří, takže zde
 * žádný překryv skutečně není.
 *
 * Pokud je aktivních více úloh zároveň, je aktivní úloha s vyšší prioritou.
 * Prioria je vyjádřena pořadím úloh na vstupu, které jsou seřazené
 * od nejdůležitější úlohy.
 *
 * Pokud je aktivních více událostí zároveň v rámci jediného kalendáře,
 * tak se vybere ta událost, která je v kalendáři uvedena jako první.
 * To je především z důvodu zjednodušení a zrychlení algoritmu.
 *
 * Kromě nepřekrývajících plánů nejsou na iterátor kladena žádná další omezení.
 * Především není zaručeno, že dva navazující plány budou mít odlišnou úlohu.
 * To je dáno specifikací iCalendar, kdy je možné vytvořit událost, která se
 * bude opakovat do nekonečna a pokus o spojení jejích událostí by zacyklil.
 * Obecně jde o libovolnou událost s dobou delší, než je její perioda.
 *
 * Iterátor prochází a vrací pouze plán pro okamžiky, kdy je nějáká úloha,
 * respektive její událost v kalendáři, aktivní.
 * V plánu tak mohou vzniknout "díry", kdy pro dané okamžiky není žádný plán.
 * Pokud se takový okamžik vloží jako počáteční, začne iterace na nejbližším
 * Iterátor tak pracuje na podobném principu jako iCalendar a jeho API,
 * ze kterých vychází.
 *
 * Zdroje:
 * - [ICAL.RecurIterator](http://mozilla-comm.github.io/ical.js/api/ICAL.RecurIterator.html)
 * @implements {Iterator.<ContentTaskPlan>}
 */
class ContentTaskPlanIterator {
  /**
   * @param {IcalApi} ICAL
   * @param {Date} atDate Okamžik, od kterého se má začít vytvářet plán.
   * @param {Array.<ContentTask>} contentTasks Obsahové úlohy, pro které se vytvoří plán.
   * Pořadí úloh je od nejdůležitější po nejméně důležitou.
   * @param {IcalExpander} expander
   * @param {number} maxInterval Maximální délka intervalu,
   * ve kterém se vyhledávají události. [s]
   * @param {IcalTimeUtil} timeUtil
   */
  constructor(ICAL, atDate, contentTasks, expander, maxInterval, timeUtil) {
    this.ICAL = ICAL;
    this.contentTasks = contentTasks;
    /**
     * Datum, pro které se má provést další plánovací iterace.
     * Zatím jde o jedinou stavovou informaci, kterou je nutné mít kvůli
     * standardizovanému rozhraní iterátoru.
     * @private
     * @type {IcalApi.Time}
     */
    this.currentDate = ICAL.Time.fromJSDate(atDate);
    this.expander = expander;
    this.maxInterval = maxInterval;
    this.timeUtil = timeUtil;
  }

  /**
   * Vyhledá aktivní událost pro libovolný okamžik v jednom kalendáři.
   * @param {IcalApi.Component} calendar Kalendář, ve kterém se událost hledá.
   * @param {IcalApi.Time} currentDate Okamžik, pro který hledat událost.
   * @private
   * @returns {IcalApi.Event.occurrenceDetails|null} Aktivní událost
   * nebo `null`, pokud již žádná aktivní událost není.
   */
  findCurrentOccurrence(calendar, currentDate) {
    // Vyhledájí se všechny události pro tuto úlohu aktivní v `currentDate`.
    const endDate = this.timeUtil.adjust(currentDate, {
      seconds: this.maxInterval
    });
    const occurrences = this.expander.expand(calendar, {
      startDate: currentDate,
      endDate
    });
    // Ze všech událostí se vybere jediná, buď ta, která je nyní aktivní,
    // případně ta, která začíná nejdříve.
    let acc = null;
    occurrences.find((occurrence) => {
      // Zjistí se, jestli událost začíná dříve, než ta v akumulátoru.
      if (
        isNil(acc) ||
        occurrence.startDate.toUnixTime() < acc.startDate.toUnixTime()
      ) {
        // Pokud ano, uloží se do akumulátoru jako kandidát na aktuální událost.
        acc = occurrence;
        // Pokud událost začíná dříve, než hledaný čas, tak byla nalezena
        // vyhovující událost a hledání se ukončí.
        if (occurrence.startDate.toUnixTime() <= currentDate.toUnixTime()) {
          return true;
        }
        // Pokud událost začíná dříve, než hledaný čas, pokračuje se v hledání.
        // Stále zde může být jiná událost, která začíná dříve,
        // respektive blíže ke `currentDate`.
        return false;
      }
      // Pokud nezačíná dříve, než ta v akumulátoru, přeskočí se na další.
      return false;
    });
    return acc;
  }

  /**
   * Vyhledá aktivní plán a úlohu pro libovolný okamžik ze seznamu úloh.
   * Plán neuvažuje překrytí jinými události a přesně tak odpovídá intervalu
   * `<startDate, endDate)` iCalendar události, ze které byl vytvořen.
   * @param {IcalApi.Time} currentDate Okamžik, pro který hledat plán.
   * @param {Array.<ContentTask>} contentTasks Seznam úloh, ze kterých se vybírá.
   * @private
   * @returns {ContentTaskIcalPlan|null} Aktivní plán nebo `null`, pokud již žádný
   * aktivní plán není.
   */
  findCurrentPlan(currentDate, contentTasks) {
    // Procházejí se všechny úlohy od té s největší prioritou.
    // Hledá se událost úlohy s nejvyšší prioritou,
    // která je pro dané datum aktivní.
    let acc = null;
    contentTasks.find((contentTask) => {
      const { planIcal } = contentTask;
      const calendar = this.ICAL.Component.fromString(planIcal);
      // Vyhledá se aktivní událost pro tuto úlohu.
      const occurrence = this.findCurrentOccurrence(calendar, currentDate);
      // Pokud nebyla žádná událost nalezena, pokračuje se další úlohou.
      if (isNil(occurrence)) {
        return false;
      }
      // Pokud byla událost nalezena, ale nezačíná dříve, než dříve nalezená,
      // tak se také pokračuje na další úlohu.
      if (
        !isNil(acc) &&
        occurrence.startDate.toUnixTime() >
          acc.occurrence.startDate.toUnixTime()
      ) {
        return false;
      }
      // Pokud byla dřívější aktivní událost nalezena, vytvoří se z ní plán.
      acc = { contentTask, occurrence };
      // Pokud již byl plán nalezen a je aktivní v aktuální okamžik,
      // tak se vyhledávání ukončí.
      // Úlohy s nižší prioritou jsou přeskočeny.
      if (occurrence.startDate.toUnixTime() <= currentDate.toUnixTime()) {
        return true;
      }
      return false;
    });
    return acc;
  }

  /**
   * Vyhledá událost v jednom kalendáři, která by jako následující přerušila
   * aktuální událost.
   * @param {IcalApi.Component} calendar Kalendář, ve kterém se událost hledá.
   * @param {IcalApi.Time} currentDate Okamžik, ve který je událost aktivní.
   * @param {IcalApi.Event.occurrenceDetails} currentOccurrence Aktivní událost
   * @private
   * @returns {IcalApi.Event.occurrenceDetails|null} Následující událost
   * nebo `null`, pokud již žádná následující událost není.
   */
  findNextOccurrence(calendar, currentDate, currentOccurrence) {
    // Vyhledájí se všechny události pro tuto úlohu aktivní mezi `currentDate`
    // a koncem aktuálního plánu.
    // Události v tomto intervalu mohou přerušit aktuální událost.
    // Pokud je aktuální datum dříve než začátek aktuální události,
    // tak se vyhledává od začátku události.
    // Interval před tím, než začne událost není zajímavý.
    const { timeUtil } = this;
    const startDate = timeUtil.max(currentOccurrence.startDate, currentDate);
    const maxEndDate = timeUtil.adjust(startDate, {
      seconds: this.maxInterval
    });
    const endDate = timeUtil.min(currentOccurrence.endDate, maxEndDate);
    const occurrences = this.expander.expand(calendar, { startDate, endDate });
    // Z vyhledaných událostí se vybere jediná, ta která začíná nejdříve.
    // Tato událost totiž přeruší aktivní událost jako první.
    let acc = null;
    occurrences.find((occurrence) => {
      // Vyhledání může probíhat i v kalendáři s aktivní událostí.
      // Aktivní událost se identifikuje pomocí UID, protože instance
      // `IcalApi.Event` mohou být odlišné a API nenabízí porovnávací metodu.
      // Jakmile se na aktivní událost narazí, ihned se ukončí vyhledávání,
      // protože událost nemůže přerušit sama sebe a následující události již
      // také nemohou, protože mají nižší prioritu.
      if (occurrence.item.uid === currentOccurrence.item.uid) {
        return true;
      }
      // První událost (bez acc), se automaticky označí jako následující,
      // protože splňuje všechny požadavky.
      // Další vyhledané události ji nahradí, pouze pokud končí později.
      if (
        isNil(acc) ||
        occurrence.startDate.toUnixTime() < acc.startDate.toUnixTime()
      ) {
        acc = occurrence;
        return false;
      }
      // Událost nekončí později, přeskočí se a hledá se dále.
      return false;
    });
    return acc;
  }

  /**
   * Vyhledá následující plán a úlohu pro libovolný okamžik z aktuálního plánu
   * a ze seznamu úloh.
   * Plán neuvažuje překrytí jinými událostmi.
   * @param {IcalApi.Time} currentDate Okamžik, ve který je plán aktivní.
   * @param {ContentTaskIcalPlan} currentPlan Aktivní plán
   * @param {Array.<ContentTask>} contentTasks Seznam úloh, ze kterých se vybírá.
   * @private
   * @returns {ContentTaskIcalPlan|null} Následující plán nebo `null`, pokud již žádný
   * následující plán není.
   */
  findNextPlan(currentDate, currentPlan, contentTasks) {
    return contentTasks.reduce((acc, contentTask) => {
      const { planIcal } = contentTask;
      const calendar = this.ICAL.Component.fromString(planIcal);
      // Vyhledá se událost pro tuto úlohu, která by v budoucnu přerušila
      // aktivní událost.
      const occurrence = this.findNextOccurrence(
        calendar,
        currentDate,
        currentPlan.occurrence
      );
      // Pokud zde nebyla žádná událost nalezena, zachová se dříve nalezená
      // a pokračuje se v hledání další úlohou.
      if (isNil(occurrence)) {
        return acc;
      }
      // Pokud zde byla událost nalezena, ale nezačíná dříve,
      // než dříve nalezená událost, tak se také pokračuje na další úlohu.
      if (
        !isNil(acc) &&
        occurrence.startDate.toUnixTime() >
          acc.occurrence.startDate.toUnixTime()
      ) {
        return acc;
      }
      // Pokud byla událost nalezena, vytvoří se z ní plán.
      // Pokračuje se v hledání, protože v jiné úloze může být stále událost
      // začínající dříve.
      return { contentTask, occurrence };
    }, null);
  }

  /**
   * Vyhledá událost v jednom kalendáři, která by jako předcházející přerušila
   * aktuální událost.
   * @param {IcalApi.Component} calendar Kalendář, ve kterém se událost hledá.
   * @param {IcalApi.Time} currentDate Okamžik, ve který je událost aktivní.
   * @param {IcalApi.Event.occurrenceDetails} currentOccurrence Aktivní událost
   * @private
   * @returns {IcalApi.Event.occurrenceDetails|null} Předcházející událost
   * nebo `null`, pokud žádná předcházející událost není.
   */
  findPreviousOccurrence(calendar, currentDate, currentOccurrence) {
    // Vyhledájí se všechny události pro tuto úlohu aktivní mezi
    // začátkem aktuálního plánu a `currentDate`.
    // Události v tomto intervalu mohou přerušit aktuální událost.
    const { timeUtil } = this;
    const minStartDate = timeUtil.adjust(currentDate, {
      seconds: -1 * this.maxInterval
    });
    const startDate = timeUtil.max(currentOccurrence.startDate, minStartDate);
    const occurrences = this.expander.expand(calendar, {
      startDate,
      endDate: currentDate
    });
    // Z vyhledaných událostí se vybere jediná, ta která začíná nejpozději.
    // Tato událost totiž přeruší aktivní událost jako poslední.
    let acc = null;
    occurrences.find((occurrence) => {
      // Vyhledání může probíhat i v kalendáři s aktivní událostí.
      // Aktivní událost se identifikuje pomocí UID, protože instance
      // `IcalApi.Event` mohou být odlišné a API nenabízí porovnávací metodu.
      // Jakmile se na aktivní událost narazí, ihned se ukončí vyhledávání,
      // protože událost nemůže přerušit sama sebe a následující události již
      // také nemohou, protože mají nižší prioritu.
      if (occurrence.item.uid === currentOccurrence.item.uid) {
        return true;
      }
      // První událost (bez acc), se automaticky označí jako předchozí,
      // protože splňuje všechny požadavky.
      // Další vyhledané události ji nahradí, pouze pokud končí později.
      if (
        isNil(acc) ||
        occurrence.endDate.toUnixTime() > acc.endDate.toUnixTime()
      ) {
        acc = occurrence;
        return false;
      }
      // Událost nekončí později, přeskočí se a hledá se dále.
      return false;
    });
    return acc;
  }

  /**
   * Vyhledá předcházející plán a úlohu pro libovolný okamžik z aktuálního plánu
   * a ze seznamu úloh.
   * Plán neuvažuje překrytí jinými událostmi.
   * @param {IcalApi.Time} currentDate Okamžik, ve který je plán aktivní.
   * @param {ContentTaskIcalPlan} currentPlan Aktivní plán
   * @param {Array.<ContentTask>} contentTasks Seznam úloh, ze kterých se vybírá.
   * @private
   * @returns {ContentTaskIcalPlan|null} Předcházející plán nebo `null`, pokud žádný
   * předcházející plán není.
   */
  findPreviousPlan(currentDate, currentPlan, contentTasks) {
    return contentTasks.reduce((acc, contentTask) => {
      const { planIcal } = contentTask;
      const calendar = this.ICAL.Component.fromString(planIcal);
      // Vyhledá se událost pro tuto úlohu, která v minulosti přerušila
      // aktivní událost.
      const occurrence = this.findPreviousOccurrence(
        calendar,
        currentDate,
        currentPlan.occurrence
      );
      // Pokud zde nebyla žádná událost nalezena, zachová se dříve nalezená
      // a pokračuje se v hledání další úlohou.
      if (isNil(occurrence)) {
        return acc;
      }
      // Pokud byla událost nalezena, ale nekončí později, než předchozí,
      // tak se také pokračuje na další úlohu.
      if (
        !isNil(acc) &&
        occurrence.endDate.toUnixTime() < acc.occurrence.endDate.toUnixTime()
      ) {
        return acc;
      }
      // Pokud byla událost nalezena, vytvoří se z ní plán.
      // Pokračuje se v hledání, protože v jiné úloze může být stále událost
      // začínající později.
      return { contentTask, occurrence };
    }, null);
  }

  /**
   * Určí konec aktivního plánu při uvážení překrytí následujícím.
   * @param {ContentTaskIcalPlan} currentPlan Aktuální plán bez překrytí
   * @param {ContentTaskIcalPlan|null} nextPlan Následující plán
   * @private
   * @returns {IcalApi.Time}
   */
  getEndDate(currentPlan, nextPlan) {
    // Nedošlo k přerušení, použije se konec aktivní události.
    if (isNil(nextPlan)) {
      return currentPlan.occurrence.endDate;
    }
    // Došlo k přerušení, použije se začátek události, která přerušila.
    return nextPlan.occurrence.startDate;
  }

  /**
   * Určí začátek aktivního plánu při uvážení překrytí předcházejícím.
   * @param {ContentTaskIcalPlan} currentPlan Aktuální plán bez překrytí
   * @param {ContentTaskIcalPlan|null} previousPlan Následující plán
   * @private
   * @returns {Date}
   */
  getStartDate(currentPlan, previousPlan) {
    // Nedošlo k přerušení, použije se začátek aktivní události.
    if (isNil(previousPlan)) {
      return currentPlan.occurrence.startDate;
    }
    // Došlo k přerušení, použije se konec události, která přerušila.
    return previousPlan.occurrence.endDate;
  }

  /**
   * Iterační metoda, která prochází plány obsahových úloh.
   * @returns {IteratorResult.<ContentTaskPlan>}
   */
  next() {
    const { currentDate, contentTasks } = this;
    // Vyhledá se úloha, která je aktivní v daný okamžik,
    // nebo nejbližší následující.
    const currentPlan = this.findCurrentPlan(currentDate, contentTasks);
    // Pokud taková úloha neexistuje, končí se iterace.
    if (isNil(currentPlan)) {
      return { done: true };
    }
    // Přerušit aktuální úlohu mohou jen události s vyšší prioritou,
    // nebo události ze stejné úlohy, proto se procházejí pouze tyto.
    const currentTask = currentPlan.contentTask;
    const currentTaskIndex = contentTasks.indexOf(currentTask);
    if (currentTaskIndex === -1) {
      throw new Error('Unknown current task.');
    }
    const relevantTasks = contentTasks.slice(0, currentTaskIndex + 1);
    // Vyhledá se jedna událost, která aktivní událost přerušuje v historii
    // a jedna událost, která přerušuje aktivní událost v budoucnosti.
    const previousPlan = this.findPreviousPlan(
      currentDate,
      currentPlan,
      relevantTasks
    );
    const nextPlan = this.findNextPlan(currentDate, currentPlan, relevantTasks);
    // Na základě (ne)přítomnosti přerušujících úloh,
    // se určí skutečný začátek a konec aktivní události s ohledem
    // na její přerušení jinou úlohou.
    const endDate = this.getEndDate(currentPlan, nextPlan);
    const startDate = this.getStartDate(currentPlan, previousPlan);
    // Skutečný konec události se uloží jako aktuální datum pro další iteraci,
    // která tak na výpočet naváže.
    this.currentDate = endDate;
    // Vrátí se výsledný plán spojením nalezené události a skutečným koncem
    // a začátkem.
    return {
      done: false,
      value: {
        contentTask: currentTask,
        endDate: endDate.toJSDate(),
        startDate: startDate.toJSDate()
      }
    };
  }
}

export default ContentTaskPlanIterator;
